import api from "./AxiosInstance";


export class UserService {

    connectUser(user) {

        return api.post("User/Connect2/Ext", user,
            {
                Headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(user)
            }).then(res => res.data)


    };
}